const updateImageModalOpen = (state, { payload }) => {
	state.imageModalOpen = payload;
};

export default updateImageModalOpen;

